module.exports = __webpack_public_path__ + "static/img/5-bg.edba821.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/5-bg.png
// module id = zZ4M
// module chunks = 1